import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../../shared';

import { ClienteIntegracaoErpImportModalComponent } from './modal';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ClienteIntegracaoErpImportModalComponent
    ],
    exports: [
        ClienteIntegracaoErpImportModalComponent
    ]
})
export class ClienteIntegracaoErpImportModule { }
